import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo'
import ReviewActivity from './ReviewActivity'
import get from 'lodash/get'
import { withRouter } from 'react-router-dom'
import { NotificationManager } from 'react-notifications'

import reviewQueries from '../../graphql/Review/'

import _ from 'lodash'
import $ from 'underscore'

class Review extends Component {
  static propTypes = {
    user: PropTypes.object
  }
  constructor(props) {
    super(props)
    this.state = {
      poiLibrary: [],
      tripGuruLibrary: [],
      tripGuideLibrary: [],
      activityLibrary: []
    }
  }
  componentWillReceiveProps = props => {
    if (props.getReview.user.planPurchases) {
      let poiLibraryNew = []
      let tripGuruNew = []
      const planPurchases = _.cloneDeep(props.getReview.user.planPurchases)
      planPurchases.map(e => {
        poiLibraryNew.push(..._.get(e, 'customizedPlan.tripGuru.contentPOIs'))
        poiLibraryNew.map(el => {
          el.createdAt = _.get(e, 'customizedPlan.createdAt')

          const destination = _.get(e, 'customizedPlan.planLocations')
          el.destination = $.pluck(destination, 'country').join(', ')

        })

        tripGuruNew.push(_.get(e, 'customizedPlan.tripGuru.userProfile'))
        tripGuruNew.map(el => {
          el.createdAt = _.get(e, 'customizedPlan.createdAt')
          el.avatar = _.get(e, 'customizedPlan.tripGuru.userProfile.imageAvatar.url')

          const destination = _.get(e, 'customizedPlan.planLocations')
          el.destination = $.pluck(destination, 'country').join(', ')
        })
      })

      this.setState({ poiLibrary: poiLibraryNew, tripGuruLibrary: tripGuruNew }, () => {
      })
    }
    if (props.getReview.user.tourBookings) {
      let activitiesLibraryNew = []
      let tripGuideNew = []
      const tourBookings = _.cloneDeep(props.getReview.user.tourBookings)
      tourBookings.map(e => {
        activitiesLibraryNew.push(_.get(e, 'localTour'))
        activitiesLibraryNew.map(el => {
          el.createdAt = _.get(e, 'localTour.createdAt')
          const destination = _.get(e, 'localTour.planLocation')
          el.destination = $.pluck(destination, 'country').join(', ')
        })

        tripGuideNew.push(_.get(e, 'localTour.tripGuide.userProfile'))
        tripGuideNew.map(el => {
          el.createdAt = _.get(e, 'localTour.createdAt')

          const destination = _.get(e, 'customizedPlan.tourLocations')
          el.destination = $.pluck(destination, 'country').join(', ')
        })
      })
      this.setState({ activityLibrary: activitiesLibraryNew, tripGuideLibrary: tripGuideNew }, () => {
      })
    }
  }

  async onPOIStarSelect(score, id) {
    console.log('on POI Select', score, id)
    const { POIStartSelect, user } = this.props
    try {
      await POIStartSelect({
        variables: {
          date: new Date(),
          score: score,
          POIid: id,
          user: user.id
        }
      }).then(success => {
        this.props.getReview.refetch()
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onGuideStarSelect(score, id) {
    console.log('on TripGuru Select', score, id)
    const { tripGuideStartSelect, user } = this.props
    try {
      await tripGuideStartSelect({
        variables: {
          date: new Date(),
          score: score,
          tripGuide: id,
          user: user.id
        }
      }).then(success => {
        this.props.getReview.refetch()
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onTripGuruStarSelect(score, id) {
    console.log('on TripGuru Select', score, id)
    const { tripGuruStartSelect, user } = this.props
    try {
      await tripGuruStartSelect({
        variables: {
          date: new Date(),
          score: score,
          tripGuru: id,
          user: user.id
        }
      }).then(success => {
        this.props.getReview.refetch()
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onActivitiesStarSelect(score, id) {
    console.log('on Activities Select', score, id)
    const { activitiesStartSelect, user } = this.props
    try {
      await activitiesStartSelect({
        variables: {
          date: new Date(),
          score: score,
          localTourId: id,
          user: user.id
        }
      }).then(success => {
        this.props.getReview.refetch()
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  leftPOITip = id => {
    this.props.history.push(`/review/poi/${id}`)
  }
  leftGuideTip = id => {
    this.props.history.push(`/review/activity-guide/${id}`)
  }
  leftGuruTripTip = id => {
    this.props.history.push(`/review/trip-guru/${id}`)
  }
  leftActivitiesTip = id => {
    this.props.history.push(`/review/localtour/${id}`)
  }

  render() {

    const { tripGuruLibrary, poiLibrary, tripGuideLibrary, activityLibrary } = this.state
    return (
      <div className="container">
        <h1 className="reviewform__title">My reviews</h1>
        <div>
          {

            tripGuruLibrary.length > 0 &&
            tripGuruLibrary.map((el, i) => {
              return (
                <ReviewActivity
                  key={el.id}
                  data={el}
                  createdAt={el.createdAt}
                  type="Travel Guru"
                  tipClick={id => {
                    this.leftGuruTripTip(id)
                  }}
                  onStartSelect={(score, id) => this.onTripGuruStarSelect(score, id)}
                />
              )
            })

          }
          {tripGuideLibrary.length > 0 &&
            tripGuideLibrary.map((el, i) => (
              <ReviewActivity
                key={el.id}
                data={el}
                createdAt={el.createdAt}
                type="Travel Guide"
                tipClick={id => {
                  this.leftGuideTip(id)
                }}
                onStartSelect={(score, id) => this.onGuideStarSelect(score, id)}
              />
            ))}
          {poiLibrary.length > 0 &&
            poiLibrary.filter(el => el.reviews.length).map((el, i) => (
              <ReviewActivity
                key={el.id}
                data={el}
                createdAt={el.createdAt}
                type="POI"
                tipClick={id => {
                  this.leftPOITip(id)
                }}
                onStartSelect={(score, id) => this.onPOIStarSelect(score, id)}
              />
            ))
          }
          {activityLibrary.length > 0 &&
            activityLibrary.map((el, i) => (
              <ReviewActivity
                key={el.id}
                data={el}
                createdAt={el.createdAt}
                type="Activities"
                tipClick={id => {
                  this.leftActivitiesTip(id)
                }}
                onStartSelect={(score, id) => this.onActivitiesStarSelect(score, id)}
              />
            ))}
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(reviewQueries.GET_REVIEW_DETAILS, {
    name: 'getReview',
    options: props => ({
      fetchPolicy: 'network-only',

      variables: {
        userId: get(props, 'user.id', '')
      }
    })
  }),
  graphql(reviewQueries.CREATE_TRIPGURU_SCOPE, {
    name: 'tripGuruStartSelect',
    options: {
      fetchPolicy: 'no-cache'
    }
  }),
  graphql(reviewQueries.CREATE_TRIPGUIDE_SCOPE, {
    name: 'tripGuideStartSelect',
    options: {
      fetchPolicy: 'no-cache'
    }
  }),
  graphql(reviewQueries.CREATE_POI_SCORE, {
    name: 'POIStartSelect',
    options: {
      fetchPolicy: 'no-cache'
    }
  }),
  graphql(reviewQueries.CREATE_ACTIVITIES_SCOPE, {
    name: 'activitiesStartSelect',
    options: {
      fetchPolicy: 'no-cache'
    }
  })
)(withRouter(Review))



// WEBPACK FOOTER //
// src/components/Rewiev/index.js